import { FieldProps } from "../../types";

interface ImageEditorProps extends FieldProps<string> {}

const ImageEditor: React.FC<ImageEditorProps> = () => {
  return <></>;
};

export default ImageEditor;
